import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: 'root'
})
export class SiteCodeService {

	uriSiteCode: string = 'user/updateBuCode';
	endpoint: string = environment.backend_Jab_url;

	constructor(private http: HttpClient) {
		this.http = http;
	}

	public saveSiteCode(siteCode: string) {
		return this.http.post(this.endpoint + this.uriSiteCode, { siteCode: Number.parseInt(siteCode) });
	}
}
